import { useCMSPageField } from '@/cms/fields'
import { useUserReviewsInitialData } from '@/scopes/products/user-reviews/hooks'
import { MobileFilters } from '../Filters/MobileFilters'
import ReviewsSummary from '../ReviewsSummary'
import { Categories } from './Categories'
import { MostBookedByLabel } from './MostBookedByLabel'
import styles from './Overview.module.css'
import { ScoreBars } from './ScoreBars'

export function Overview() {
  const { reviewsAmount } = useUserReviewsInitialData()
  const ratingsCountDataSource = useCMSPageField('userReviews.ratingsCount')
  const displayedReviewsAmount = reviewsAmount || ratingsCountDataSource
  const shouldShowSummary = displayedReviewsAmount > 2

  if (!shouldShowSummary)
    return null

  return (
    <>
      <MobileFilters />
      <div className={styles.wrapper}>
        <ReviewsSummary reviewsAmount={reviewsAmount} />
        <ScoreBars />
        <div>
          <MostBookedByLabel />
        </div>
        <Categories />
      </div>
    </>
  )
}
